import moment from 'moment';
import { ISelected } from '../common/hierarchy/SearchHierarchy';
import { ITreeItem } from '../common/treeview/TreeItem';
import { ITreeItemParentBinderView } from './types';
import { ILevel } from './useViewer';

export const getTreeItem = (nodeId: string, text: string, child?: ITreeItem[]): ITreeItem => {
  return { nodeId, text, child };
};

export const getTreeItems = (treeitems: ITreeItemParentBinderView[]): ITreeItem[] => {
  const treeviewItems: ITreeItem[] = [];
  for (const first of treeitems) {
    const firstLevel = getTreeItem(first.document_priority.toString(), `${first.zone} ${first.tmf_document_type}`, []);
    for (const second of first.tmf_document_subtype) {
      const secondLevel = getTreeItem(
        `${first.document_priority} ${second.document_subtype_priority}`,
        `${second.section} ${second.tmf_document_subtype}`,
        []
      );
      for (const third of second.tmf_artifact) {
        const thirdLevel = getTreeItem(
          `${first.document_priority} ${second.document_subtype_priority} ${third.artifact_priority}`,
          `${third.tmf_artifact_number} ${third.tmf_artifact_name.replace(/ *\([^)]*\) */g, '')}`
        );
        secondLevel.child?.push(thirdLevel);
      }
      firstLevel.child?.push(secondLevel);
    }
    treeviewItems.push(firstLevel);
  }
  return treeviewItems;
};

export const getParentNodes = (arr: string[]): string[] => {
  return arr.filter(val => val.toString().indexOf(' ') === -1);
};

export const notInArray = (arr1: string[], arr2: string[]): string[] => {
  return arr1.filter(val => !arr2.includes(val));
};

export const formatDate = (value: any, dateFormat: string) => {
  if (value) {
    return moment(new Date(value)).format(dateFormat);
  }
  return;
};

export const getQuery = (level: ILevel, menu: ISelected, from: number, size: number): string => {
  let otherSelection = '';
  if (menu.study) {
    if (level && menu.study) {
      if (level.secondlevel && level.thirdlevel) {
        otherSelection = `tmf_doc_type=${level.firstlevel?.tmf_document_type}&tmf_doc_subtype=${level.secondlevel?.tmf_document_subtype}&tmf_artifact_number=${level.thirdlevel?.tmf_artifact_number}`;
      } else if (level.secondlevel) {
        otherSelection = `tmf_doc_type=${level.firstlevel?.tmf_document_type}&tmf_doc_subtype=${level.secondlevel?.tmf_document_subtype}`;
      } else {
        otherSelection = `tmf_doc_type=${level.firstlevel?.tmf_document_type}`;
      }
      let type = '';
      let tmfLevel = '';
      if (
        menu.study !== '--' &&
        menu.study !== undefined &&
        menu.study !== '' &&
        menu.study !== null &&
        (menu.country === '--' || menu.country === undefined || menu.country === '' || menu.country === null) &&
        (menu.site === '--' || menu.site === undefined || menu.site === '' || menu.site === null)
      ) {
        type = `study_id=${menu.study}`;
        tmfLevel = 'Study';
      } else if (
        menu.country !== '--' &&
        menu.country !== undefined &&
        menu.country !== '' &&
        menu.country !== null &&
        (menu.site === '--' || menu.site === undefined || menu.site === '')
      ) {
        type = `study_id=${menu.study}&country_id=${menu.country}`;
        tmfLevel = 'Country';
      } else if (menu.site !== '--' && menu.site !== undefined && menu.site !== '' && menu.country !== null) {
        type = `study_id=${menu.study}&country_id=${menu.country}&site_id=${menu.site}`;
        tmfLevel = 'Site';
      }
      otherSelection = `?${
        type !== '' ? type + '&' : ''
      }${otherSelection}&tmf_doc_level=${tmfLevel}&is_binder_view=false&from=${from}&size=${size}`;
    }
  }
  return otherSelection;
};

export const getLevel = (nodeId: string, data: ITreeItemParentBinderView[] | undefined): ILevel => {
  const [first, second = -1, third = -1] = nodeId.split(' ').map(i => Number(i));
  const firstlevel = data?.find(item => item.document_priority === first);
  const secondlevel = firstlevel?.tmf_document_subtype.find(item => item.document_subtype_priority === second);
  const thirdlevel = secondlevel?.tmf_artifact.find(item => item.artifact_priority === third);
  return { firstlevel, secondlevel, thirdlevel };
};
